import type { ConnectToForgeParameters } from '../types';

export function getConnectMacroId(parameters: ConnectToForgeParameters) {
	return parameters?.macroMetadata?.macroId?.value;
}
